import { api } from './api';
import { ApiResponse } from '../types/api';
import { User, LoginCredentials } from '../types';

export interface LoginResponse {
  user: User;
  token: string;
}

export const authService = {
  // Login user
  login: async (credentials: LoginCredentials): Promise<ApiResponse<LoginResponse>> => {
    const response = await api.post<LoginResponse>('/auth/login', credentials);
    
    // Store token in localStorage on successful login
    if (response.success && response.data?.token) {
      localStorage.setItem('auth_token', response.data.token);
    }
    
    return response;
  },

  // Logout user
  logout: async (): Promise<ApiResponse<null>> => {
    const response = await api.post<null>('/auth/logout');
    
    // Remove token from localStorage
    localStorage.removeItem('auth_token');
    
    return response;
  },

  // Validate current token
  validateToken: async (): Promise<ApiResponse<{ valid: boolean }>> => {
    return api.post<{ valid: boolean }>('/auth/validate');
  },

  // Refresh token
  refreshToken: async (): Promise<ApiResponse<{ token: string }>> => {
    const response = await api.post<{ token: string }>('/auth/refresh');
    
    // Update token in localStorage
    if (response.success && response.data?.token) {
      localStorage.setItem('auth_token', response.data.token);
    }
    
    return response;
  },

  // Get current user profile
  getCurrentUser: async (): Promise<ApiResponse<User>> => {
    return api.get<User>('/user/me');
  },
};